// NOTE dayJs() converts into Europe/Amsterdam, and every conversion costs a fresh
// Intl.DateTimeFormat. The old version converted per month x per event x per
// range (~3,400 calls for a year of events, ~2s of SSR on /events). Each range is
// now converted once into month indices (year * 12 + month) and cached per entry.
const monthSpansCache = new WeakMap<object, { start: number, end: number }[]>()

const toMonthIndex = (date: string) => {
  const dateJs = dayJs(date)
  return dateJs.year() * 12 + dateJs.month()
}

export const eventsMonthIndexToString = (index: number) => {
  const year = Math.floor(index / 12)
  const month = String(index % 12 + 1).padStart(2, '0')
  return `${year}-${month}-01`
}

export const eventsStringToMonthIndex = (month: string) => {
  const [year, monthNumber] = month.split('-').map(Number)
  return year * 12 + monthNumber - 1
}

export const eventsGetMonthSpans = (entry: object) => {
  if (!entry) return []
  if (monthSpansCache.has(entry)) return monthSpansCache.get(entry)

  const spans = (entry?.attributes?.dateTimeRanges || [])
    .filter((dateTimeRange: object) => dateTimeRange?.dateTimeStart && dateTimeRange?.dateTimeEnd)
    .map((dateTimeRange: object) => ({
      start: toMonthIndex(dateTimeRange.dateTimeStart),
      end: toMonthIndex(dateTimeRange.dateTimeEnd)
    }))

  monthSpansCache.set(entry, spans)
  return spans
}

// NOTE a range contributes its start and end month only, not the months in between
export const eventsGetStartOfMonths = (eventsData: array = [], year: number) => {
  const months = new Set<number>()
  eventsData?.forEach(entry => {
    eventsGetMonthSpans(entry).forEach(({ start, end }) => {
      months.add(start)
      months.add(end)
    })
  })

  return [...months]
    .filter(index => Math.floor(index / 12) === year)
    .sort((a, b) => a - b)
    .map(eventsMonthIndexToString)
}
